export const ALPHA_DEFINITIONS = {
    disabled: 0.12,
    active: 0.08,
    stroke: 0.12,
    tint: 0.6,
};
//# sourceMappingURL=alpha.js.map